import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/dashboard/Sidebar'

export function DashboardLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 md:pl-64 transition-all duration-300 ease-in-out">
        <div className="container p-6 md:p-8 pt-16 md:pt-8 max-w-7xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
